import PaypalPaymentStatus from './PaypalPaymentStatus';

export default PaypalPaymentStatus;
